import { IntervalType } from '@dokucoach/common-types';
import { keys } from 'lodash';
import * as yup from 'yup';
import { ICheckboxValue } from '../../../common';

export const PrescriptionSchema = yup.object({
  vitalSignType: yup.string().required(),
  intervalNumber: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.INTERVAL,
    then: yup.number().required('Angabe erforderlich').typeError('Angabe erforderlich'),
  }),
  weekdays: yup.mixed().when('interval', {
    is: (v: string) => v === IntervalType.WEEKDAYS,
    then: yup.object().shape({
      value: yup.array().min(1).of(yup.string()).required('Angabe erforderlich'),
    }),
  }),
  interval: yup
    .mixed()
    .oneOf(keys(IntervalType), 'Angabe erforderlich')
    .required('Angabe erforderlich'),
  scheduledDate: yup.date().required(),
  readOutChecked: yup.boolean().notRequired().nullable(),
  selectedDoctorId: yup.string().notRequired().default(undefined).nullable(),
  discontinuedChecked: yup.boolean().notRequired().nullable(),
  discontinuedScheduledDate: yup.mixed().when('discontinuedChecked', {
    is: true,
    then: yup.date().required(),
  }),
  discontinuedReadOutChecked: yup.mixed().when('discontinuedChecked', {
    is: true,
    then: yup.boolean().notRequired().nullable(),
  }),
  discontinuedSelectedDoctorId: yup.string().notRequired().default(undefined).nullable(),
  remark: yup.string().notRequired().nullable(),
});

export interface IPrescription {
  vitalSignType: string;
  intervalNumber: number;
  weekdays: ICheckboxValue;
  interval: IntervalType;
  scheduledDate: Date;
  readOutChecked?: boolean;
  selectedDoctorId: string;
  discontinuedChecked?: boolean;
  discontinuedAt?: Date;
  discontinuedScheduledDate: Date;
  discontinuedReadOutChecked?: boolean;
  discontinuedSelectedDoctorId: string;
  nursingTaskId?: string;
  remark?: string | null;
}

export const CreatePrescriptionSchema = yup
  .object({
    residentId: yup.string(),
  })
  .concat(PrescriptionSchema);

export interface ICreatePrescription extends IPrescription {
  residentId: string;
}

export const UpdatePrescriptionSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(PrescriptionSchema);

export interface IUpdatePrescription extends IPrescription {
  id: string;
}
